import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import { Container } from "./styles";

function ShimmerCategory() {
  return (
    <Container>
      <Skeleton className="icon" height={40} width={40} circle />
      <Skeleton className="title" height={20} width="80%" />
    </Container>
  );
}

export default ShimmerCategory;
